import { useCallback, useMemo } from 'react';
import _ from 'lodash';
import { useTranslation } from '@translation/api/api-hooks';

const trimText = (text) => {
  const result = /^[\s\W]*(.*?)[\s\W]*$/.exec(text);
  return result === null ? text : result[1];
};

export function useTranslationText(text, language) {
  const enabled = !!text && !!language && language !== 'en';
  const {
    data: translated,
    isLoading,
    isError,
  } = useTranslation(text, language, { enabled });

  const trimmedOriginal = useMemo(() => trimText(text), [text]);

  const trimmedTranslated = useMemo(() => {
    if (!translated) return '';
    return trimText(translated.target_text || '');
  }, [translated]);

  const textWithTranslation = useMemo(() => {
    if (!_.isString(text)) return text;
    if (translated) {
      const targetText = translated.target_text || '';
      const trimmedTranslated = trimText(targetText);
      return `${trimmedTranslated} - ${trimmedOriginal}`;
    }

    return text;
  }, [text, translated, trimmedOriginal]);

  const getTranslatedText = useCallback(() => {
    return trimmedTranslated;
  }, [trimmedTranslated]);

  return {
    translated: translated ? translated.target_text : '',
    textWithTranslation,
    trimmedOriginal,
    isTranslated: !!translated && translated !== text,
    isLoading,
    isError,
    trimmedTranslated,
    getTranslatedText,
  };
}
